import React from 'react'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'

import { pathKey } from '../../utils'

export const useMainQueryKey = () => {
  const { brandAccountId } = usePathParams(pathKey)

  return React.useMemo(
    () => ['TimeSeriesSettingsPage_Main', { brandAccountId }],
    [brandAccountId],
  )
}
